import React, {useState, useEffect, FC} from 'react';
import * as fonts from '../../../../../util/fonts';
import './styles.scss';
import 'antd/dist/antd.css';
import colors from '../../../../../util/colors';
import * as Yup from 'yup';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../../../util/strings';
import {
  uriGetClinic,
  uriGetClinicCategories,
  uriGetClinicCategoriesSpecialities,
  uriGetClinicProcedureMedics,
  uriGetClinicProcedureMedicsFiltered,
  uriGetClinicProcedures,
  uriGetClinicSpecialityProcedures,
  uriGetMedicsExamesProcedures,
  uriGetProcedureClinic,
} from '../../../../../api/endpoints';
import {get, getWithCustomHeaders} from '../../../../../api/api';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '../../../../permissions/components/TabPanel';
import {useMediaQuery} from 'react-responsive';
import TabDetails from './TabDetails';
import ClinicsInfo from './ClinicsInfo';
import AppButton from '../../../../../components/app-button';
import {Row} from '../../../../../components/layout';
import {filterActiveCategories} from '../../../../../util/utility';

const validationSchema = Yup.object().shape({});

interface Stage2ClinicsProps {
  buStyles: any;
  selectedClinic: any;
  selectedClinicSection: any;
  labels: typeof strings.pt.rede;
  labelsPrecos: typeof strings.pt.redePrecos;
  precoEstimadoAtivo: boolean;
  selectedBu?: any;
  network?: any;
  precoEstimadoFuncAtiva: boolean;
  showPrice: boolean;
  loadMedicData(value: any): void;
  accessToken: any;
  filterTab: boolean;
  selectedCode: number;
  selectedCategoryCode: number;
  selectedSpecialtyCode: number;
  setFilterTab(value: any): void;
}

const Stage2Clinics: FC<Stage2ClinicsProps> = ({
  selectedClinic,
  selectedClinicSection,
  labels,
  labelsPrecos,
  precoEstimadoAtivo,
  precoEstimadoFuncAtiva,
  selectedBu,
  network,
  buStyles,
  showPrice,
  filterTab,
  selectedCode,
  selectedCategoryCode,
  selectedSpecialtyCode,
  loadMedicData,
  accessToken,
  setFilterTab,
}) => {
  const clinicKey: any = Object.keys(selectedClinicSection).find(
    (el: any) => selectedClinicSection[el].code === selectedClinic
  );
  const clinicObject: any = clinicKey ? selectedClinicSection[clinicKey] : {};
  const clinicName = clinicObject.name;
  const email = clinicObject.email;
  const phone = clinicObject.phone;
  const url = clinicObject.url;
  const address = `${clinicObject.address}, ${clinicObject.postalCode}, ${clinicObject.parish} `;

  const [tabValue, setTabValue] = useState(0);
  const [showAccordionDetails, setShowAccordionDetails] = useState(false);
  const [expanded, setExpanded] = useState('');
  const [resetScroll, setResetScroll] = useState(true);
  const [examSpeciality, setExamSpeciality] = useState([]);
  const [examSpecialtyFiltered, setExamSpecialtyFiltered] = useState([]);

  const handleTab = (event: React.ChangeEvent<{}>, value: any) => {
    setTabValue(value);
  };

  const [clinicCategories, setClinicCategories]: any = useState([]);
  const [clinicProcedures, setClinicProcedures] = useState([]);
  const [clinicProceduresFiltered, setClinicProceduresFiltered] = useState([]);

  const [categoryProcedures, setCategoryProcedures] = useState([]);
  const [categoryPrices, setCategoryPrices]: any = useState([]);
  const [medicsForProcedure, setMedicsForProcedure] = useState([]);
  const [medicsPrices, setMedicPrices]: any = useState([]);
  const [medicList, setMedicList]: any = useState([]);
  const [listEmpty, setListEmpty] = useState(true);
  const [examList, setExamList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [displayTabs, toggleDisplayTabs] = useState(false);
  const [showTabs, setShowTabs] = useState(false);
  const [appendedNameForExamFiltered, setAppendedNameForExamFiltered] =
    useState('');

  useEffect(() => {
    getClinic();
  }, []);

  useEffect(() => {
    setShowTabs(displayTabs && clinicCategories.length > 0);
  }, [displayTabs, clinicCategories, categoryProcedures]);

  const token = accessToken;
  const headers =
    labels?.medicalNetwork_toggleHeaders === 'true'
      ? {
          Unit: selectedBu.buId,
          Family: selectedBu.famId,
          Fiscal: selectedBu.nif,
          Authorization: 'Bearer ' + token,
          Member: selectedBu.memId,
        }
      : {
          Unit: selectedBu.buId,
          Family: selectedBu.famId,
          Fiscal: selectedBu.nif,
          Authorization: 'Bearer ' + token,
        };

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});

  useEffect(() => {
    scrollToTab();
  }, []);

  const scrollToTab = () => {
    setResetScroll(false);
    window.scroll({top: isResponsive ? 700 : 250, behavior: 'smooth'});
  };

  const getClinic = async () => {
    try {
      await get(uriGetClinic(selectedClinic));
    } catch {}
  };

  const getClinicSpecialities = async () => {
    try {
      await getWithCustomHeaders(
        uriGetClinicCategoriesSpecialities(
          selectedClinic,
          parseInt(labels.medicalNetwork_exams_code),
          network
        ),
        headers
      ).then((res: any) => {
        setExamSpeciality(res?.data?.specialities);
        let aux = res?.data?.specialities.filter(
          (item: any) => item.code === selectedSpecialtyCode
        );
        setExamSpecialtyFiltered(aux);
      });
    } catch {}
  };

  const getClinicProcedures = async () => {
    try {
      await getWithCustomHeaders(
        uriGetClinicProcedures(selectedClinic, network),
        headers
      ).then((res: any) => {
        const filteredResults = res?.data?.procedures.filter(
          (el: any) =>
            el.category.code ===
            parseInt(labels.medicalNetwork_appointments_code)
        );
        const contextResult = filteredResults.filter(
          (item: any) => item.code === selectedCode
        );
        setClinicProceduresFiltered(contextResult);
        setClinicProcedures(filteredResults);
      });
    } catch (e: any) {}
  };

  const getMedicsForProcedure = async (procedure: any) => {
    setLoading(true);
    getWithCustomHeaders(
      uriGetMedicsExamesProcedures(selectedClinic, procedure.code, network),
      headers
    )
      .then((res: any) => {
        setMedicsForProcedure(res?.data?.medics);
        labelsPrecos?.medicalNetwork_show_price_exam === '1' &&
          precoEstimadoAtivo &&
          getPrices('exams', procedure.code, procedure.speciality.code);
        setLoading(false);
      })
      .catch((e: any) => {
        setMedicsForProcedure([]);
        setLoading(false);
      });
  };

  const getClinicCategories = async () => {
    try {
      await getWithCustomHeaders(
        uriGetClinicCategories(selectedClinic, network),
        headers
      ).then((res: any) => {
        // DON'T DELETE: Use this when all the 3 tabs are to be displayed
        // const tabCategories = res.categories.filter((category: any) => category.description !== "Outras")

        // This was implemented to only show the tab 'Consultas', because it was the sprint 2 scope
        const tabCategories = filterActiveCategories(
          labels.medicalNetwork_inactiveCategories,
          res?.data?.categories
        ).filter(
          (category: any) =>
            category.description === 'Exames' ||
            category.description === 'Consultas'
        );

        tabCategories.sort((a: any, b: any) =>
          a.catCode > b.catCode ? 1 : b.catCode > a.catCode ? -1 : 0
        );
        setClinicCategories(tabCategories);
        if (
          filterTab &&
          selectedCategoryCode ===
            parseInt(labels.medicalNetwork_appointments_code)
        ) {
          const tabValue = tabCategories.findIndex(
            (obj: any) =>
              obj['code'] ===
              (selectedCategoryCode ===
              parseInt(labels.medicalNetwork_appointments_code)
                ? parseInt(labels.medicalNetwork_appointments_code)
                : parseInt(labels.medicalNetwork_exams_code))
          );
          setTabValue(tabValue);
        }
        tabCategories.length > 0 && toggleDisplayTabs(true);
      });
    } catch (e: any) {}
  };

  const getPrices = async (
    tab: string,
    code: number,
    specialityCode?: number
  ) => {
    await getWithCustomHeaders(
      uriGetProcedureClinic(code, selectedClinic, network),
      headers
    )
      .then((res: any) => {
        if (tab === 'appointments') {
          let prices = categoryPrices;
          prices.push({code: code, price: res?.data?.procedures?.[0]?.price});
          setCategoryPrices(prices);
          setLoading(false);
        } else if (tab === 'exams' && specialityCode) {
          let prices = medicsPrices;
          prices.push({
            code: specialityCode,
            price: res?.data?.procedures?.[0]?.price,
          });
          setMedicPrices(prices);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const resetPrices = (tab: string) => {
    if (tab === 'exams') {
      setMedicPrices([]);
    }
  };
  const handleChange = (code: any) => (event: any, isExpanded: any) => {
    setLoading(true);
    setExpanded(isExpanded ? code : false);
    if (isExpanded) {
      getWithCustomHeaders(
        uriGetClinicProcedureMedics(selectedClinic, code, network),
        headers
      )
        .then((res: any) => {
          setMedicList(res?.data);
          setListEmpty(res?.data?.length);
          labelsPrecos?.medicalNetwork_show_price_appointment === '1' &&
            precoEstimadoAtivo &&
            getPrices('appointments', code);
          setLoading(false);
        })
        .catch(() => {
          setListEmpty(true);
          setMedicList([]);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const handleChangeExams =
    (code: any) => async (event: any, isExpanded: any) => {
      setLoading(true);
      setExpanded(isExpanded ? code : false);
      setMedicPrices([]);
      if (isExpanded) {
        await getWithCustomHeaders(
          uriGetClinicSpecialityProcedures(
            selectedClinic,
            code,
            network,
            parseInt(labels.medicalNetwork_exams_code)
          ),
          headers
        )
          .then((res: any) => {
            !appendedNameForExamFiltered && setExamList(res?.data?.procedures);
            if (
              filterTab &&
              selectedCategoryCode ===
                parseInt(labels.medicalNetwork_exams_code)
            ) {
              let aux = res?.data?.procedures.find(
                (item: any) => item.code === selectedCode
              );
              setAppendedNameForExamFiltered(
                `${aux.speciality.description} / ${aux.name}`
              );
              getMedicsForProcedure(aux);
            } else {
              setLoading(false);
            }
            setListEmpty(false);
          })
          .catch((err) => {
            setListEmpty(true);
            setExamList([]);
            setLoading(false);
          });
      }
    };

  const handleOnShowAllAppointmentsClick = () => {
    setFilterTab(false);
  };

  const renderAppointments = () => {
    return filterTab &&
      selectedCategoryCode === parseInt(labels.medicalNetwork_appointments_code)
      ? clinicProceduresFiltered.map((procedure: any, index: any) => {
          if (index === clinicProceduresFiltered.length - 1) {
            resetScroll && scrollToTab();
          }
          return (
            <>
              <TabDetails
                procedure={procedure}
                speciality={procedure.name}
                dataList={medicList.medics}
                expanded={expanded}
                handleChange={handleChange}
                clickFunction={loadMedicData}
                listEmpty={listEmpty}
                loading={loading}
                index={index}
                prices={categoryPrices}
                filtered={filterTab}
              />
              <div className="show-all-button-container">
                <AppButton
                  variant="primary"
                  onClick={() => handleOnShowAllAppointmentsClick()}
                  className="show-all-appointments-button">
                  {labels.medicalNetwork_show_all_appointments}
                </AppButton>
              </div>
            </>
          );
        })
      : categoryProcedures.map((procedure: any, index: any) => {
          if (index === categoryProcedures.length - 1) {
            resetScroll && scrollToTab();
          }
          return (
            <TabDetails
              procedure={procedure}
              speciality={procedure.name}
              dataList={medicList.medics}
              expanded={expanded}
              handleChange={handleChange}
              clickFunction={loadMedicData}
              listEmpty={listEmpty}
              loading={loading}
              index={index}
              prices={categoryPrices}
            />
          );
        });
  };

  const renderExams = () => {
    return filterTab &&
      selectedCategoryCode === parseInt(labels.medicalNetwork_exams_code)
      ? examSpecialtyFiltered.map((el: any, index: any) => {
          if (index === categoryProcedures.length - 1) {
            resetScroll && scrollToTab();
          }
          return (
            <>
              <TabDetails
                procedure={el}
                dataList={examList}
                speciality={el.description}
                expanded={expanded}
                handleChange={handleChangeExams}
                listEmpty={listEmpty}
                loading={loading}
                index={index}
                clickFunction={getMedicsForProcedure}
                redirectToMedicDetails={loadMedicData}
                loadMedics={true}
                medicsList={medicsForProcedure}
                prices={medicsPrices}
                resetPrices={resetPrices}
                filtered={filterTab}
                selectedCategoryCode={selectedCategoryCode}
                selectedSpecialtyCode={selectedSpecialtyCode}
                appendedNameForExamFiltered={appendedNameForExamFiltered}
              />
              <div className="show-all-button-container">
                <AppButton
                  variant="primary"
                  onClick={() => handleOnShowAllAppointmentsClick()}
                  className="show-all-appointments-button">
                  {labels.medicalNetwork_show_all_exams}
                </AppButton>
              </div>
            </>
          );
        })
      : examSpeciality.map((el: any, index: any) => {
          if (index === categoryProcedures.length - 1) {
            resetScroll && scrollToTab();
          }
          return (
            <TabDetails
              procedure={el}
              dataList={examList}
              speciality={el.description}
              expanded={expanded}
              handleChange={handleChangeExams}
              listEmpty={listEmpty}
              loading={loading}
              index={index}
              clickFunction={getMedicsForProcedure}
              redirectToMedicDetails={loadMedicData}
              loadMedics={true}
              medicsList={medicsForProcedure}
              prices={medicsPrices}
              resetPrices={resetPrices}
            />
          );
        });
  };

  const renderCategoryProcedures = (tabValue: number) => {
    const tabName = clinicCategories[tabValue].description;
    switch (tabName) {
      case 'Consultas':
        return renderAppointments();

      case 'Exames':
        return renderExams();
      default:
        return <></>;
    }
  };

  const renderTabs = () => {
    return (
      <div className="tabs tabs-wrapper">
        <Tabs
          className="tab-parent"
          value={tabValue}
          orientation="horizontal"
          onChange={handleTab}
          indicatorColor="primary"
          TabIndicatorProps={{style: {backgroundColor: 'transparent'}}}
          style={{minHeight: '30px'}}>
          {clinicCategories.map((category: any, index: any) => (
            <Tab
              key={category.code}
              id={index}
              value={index}
              className="tab"
              label={
                <span
                  style={{
                    ...fonts.M,
                    ...fonts.Bold,
                    paddingBottom: '12px',
                    color:
                      tabValue === index ? colors.white : buStyles.primaryColor,
                  }}>
                  {category?.description}
                </span>
              }
              wrapped={false}
            />
          ))}
        </Tabs>
        <div
          className="tab-separator"
          style={{backgroundColor: colors.black, height: '2px'}}
        />
        {clinicCategories.map((category: any, index: any) => (
          <TabPanel value={tabValue} index={index}>
            {renderCategoryProcedures(tabValue)}
          </TabPanel>
        ))}
      </div>
    );
  };

  useEffect(() => {
    if (clinicCategories.length > 0) {
      const proceduresList = clinicProcedures.filter(
        (procedure: any) =>
          procedure.category.code === clinicCategories[tabValue].code
      );
      setCategoryProcedures(proceduresList);
      if (
        filterTab &&
        selectedCategoryCode ===
          parseInt(labels.medicalNetwork_appointments_code)
      ) {
        handleChange(selectedCode)(null, true);
      } else if (
        filterTab &&
        selectedCategoryCode === parseInt(labels.medicalNetwork_exams_code)
      ) {
        handleChangeExams(selectedSpecialtyCode)(null, true);
      }
    }
  }, [clinicProcedures, tabValue, appendedNameForExamFiltered]);

  //mostra a tab default q estiver em primeiro na lista de categories
  useEffect(() => {
    if (displayTabs) {
      getClinicProcedures();
      getClinicSpecialities();
    }
  }, [displayTabs]);

  useEffect(() => {
    getClinicCategories();
  }, []);

  return (
    <div className="medic-name-title-container">
      <ClinicsInfo
        name={clinicName}
        phone={phone}
        email={email}
        precoEstimadoFuncAtiva={precoEstimadoFuncAtiva}
        url={url}
        showPrice={showPrice}
        clinic={clinicObject}
        address={address}
      />
      {showTabs && renderTabs()}
    </div>
  );
};

const mapStateToProps = ({
  globalStyles,
  strings,
  selectedBu,
  accessToken,
}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.rede,
  selectedBu: selectedBu.value,
  labelsPrecos: strings.value.pt.redePrecos,
  accessToken: accessToken.value,
});

export default compose(connect(mapStateToProps)(Stage2Clinics));
